import { render } from "./mobile-bottom-menu.vue?vue&type=template&id=009f9577"
import script from "./mobile-bottom-menu.vue?vue&type=script&lang=js"
export * from "./mobile-bottom-menu.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__